import { useState, useEffect, useCallback } from 'react'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import classes from './pozitivnaLinija.module.css'
import ResultsSection from '../redesign/components/ResultsSection'
import add from '../images/add.svg'

const calculatorType = 'Pozitivna linija'

const debounce = (func, wait) => {
  let timeout
  function debounced(...args) {
    clearTimeout(timeout)
    timeout = setTimeout(() => func.apply(this, args), wait)
  }
  debounced.cancel = () => clearTimeout(timeout)
  return debounced
}

const PozitivnaLinija = () => {
  const [showInputArea, setShowInputArea] = useState(true)
  const [error, setError] = useState(false)
  const [series, setSeries] = useState([{ id: 1 }])

  const [data, setData] = useState({
    values: {
      serie1: {
        stake: '',
        odds: '',
        hasPassed: '',
        percentage: '',
        missOdds: '',
      },
    },
    result: {
      serie1Results: ['-', '-', '-', '-', '-', '-'],
    },
  })

  const clearFields = () => {
    setData((prevData) => {
      const clearedValues = {}
      const clearedResults = {}

      Object.keys(prevData.values).forEach((key) => {
        clearedValues[key] = {
          stake: '',
          odds: '',
          hasPassed: '',
          percentage: '',
          missOdds: '',
        }
      })

      Object.keys(prevData.result).forEach((key) => {
        clearedResults[key] = ['-', '-', '-', '-', '-', '-']
      })

      return {
        values: clearedValues,
        result: clearedResults,
      }
    })

    setSeries([{ id: 1 }])
  }

  const handleCalculate = useCallback(() => {
    setData((prevData) => {
      const newResults = {}
      const newValues = { ...prevData.values }
      const seriesKeys = Object.keys(prevData.values)

      seriesKeys.forEach((serieKey, index) => {
        const current = prevData.values[serieKey]

        const stake = parseFloat(current.stake) || 0
        const odds = parseFloat(current.odds)
        const hasPassed = (current.hasPassed || '').toLowerCase()
        const percentage = parseFloat(current.percentage)

        const potentialProfit =
          isNaN(stake) || isNaN(odds) ? 0 : +(stake * odds).toFixed(2)

        let netProfit
        if (isNaN(potentialProfit) || isNaN(stake)) {
          netProfit = 0
        } else if (potentialProfit > 0 && hasPassed === 'da') {
          netProfit = +(potentialProfit - stake).toFixed(2)
        } else if (potentialProfit > 0 && hasPassed === 'ne') {
          netProfit = -stake
        } else {
          netProfit = 0
        }

        const transferAmount =
          isNaN(netProfit) || isNaN(percentage)
            ? 0
            : +((netProfit * percentage) / 100).toFixed(2)

        const recalculatedStake =
          hasPassed === 'da' ? Math.abs(transferAmount) : stake

        const resultStatus =
          percentage > 0
            ? 'U PLUSU STE'
            : percentage === 0
            ? 'NA NULI STE'
            : `${netProfit}`

        newResults[`${serieKey}Results`] = [
          potentialProfit.toString(),
          netProfit.toString(),
          transferAmount.toString(),
          recalculatedStake.toString(),
          netProfit.toString(),
          resultStatus,
        ]

        const nextKey = seriesKeys[index + 1]
        if (nextKey) {
          newValues[nextKey] = {
            ...newValues[nextKey],
            stake: Math.abs(transferAmount).toString(),
          }
        }
      })

      return {
        ...prevData,
        values: {
          ...newValues,
        },
        result: {
          ...prevData.result,
          ...newResults,
        },
      }
    })
  }, [])

  const debouncedCalculate = useCallback(
    debounce(() => {
      handleCalculate()
    }, 100),
    [handleCalculate]
  )

  useEffect(() => {
    debouncedCalculate()
    return () => debouncedCalculate.cancel()
  }, [data.values, debouncedCalculate])

  const addSeries = () => {
    setSeries((prevSeries) => {
      const newSeries = [...prevSeries, { id: prevSeries.length + 1 }]
      const newKey = `serie${newSeries.length}`

      setData((prevData) => ({
        ...prevData,
        values: {
          ...prevData.values,
          [newKey]: {
            stake: '',
            odds: '',
            hasPassed: '',
            percentage: '',
            missOdds: '',
          },
        },
        result: {
          ...prevData.result,
          [`${newKey}Results`]: ['-', '-', '-', '-', '-', '-'],
        },
      }))

      return newSeries
    })
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        {showInputArea && (
          <div className={classesK.sectionContainer}>
            <div className={classesK.sectionTitle}>Igra</div>
            <div
              className={`${classesK.oddsContainer} ${classes.pozitivnaLinijaCalc}`}
            >
              <span>Upiši ulog</span>
              <input
                type='number'
                step='1'
                min='1'
                value={data.values.serie1.stake[0]}
                onChange={(e) => {
                  const value = parseFloat(e.target.value)
                  setData((prevData) => ({
                    ...prevData,
                    values: {
                      ...prevData.values,
                      serie1: {
                        ...prevData.values.serie1,
                        stake: value,
                      },
                    },
                  }))
                }}
                className={classes.oddsInput}
              />
            </div>

            {series.map((series) => {
              const serieKey = `serie${series.id}`
              return (
                <div key={series.id} className={classes.seriesContainer}>
                  <div className={classes.seriesTitle}>
                    Serija br. {series.id}
                  </div>
                  <div className={classes.seriesValues}>
                    <div className={classes.wrapper}>
                      {series.id > 1 && (
                        <ResultsSection
                          names={['Ulog']}
                          results={[data.values[serieKey].stake]}
                          allowNegative={true}
                        />
                      )}

                      <div className={classesK.oddsContainer}>
                        <span>Upiši kvotu</span>
                        <input
                          type='number'
                          value={data.values[serieKey].odds}
                          onChange={(e) => {
                            const value = e.target.value
                            setData((prevData) => ({
                              ...prevData,
                              values: {
                                ...prevData.values,
                                [serieKey]: {
                                  ...prevData.values[serieKey],
                                  odds: value,
                                },
                              },
                            }))
                          }}
                          step='0.1'
                          min='0.1'
                        />
                      </div>
                    </div>

                    <div className={classes.wrapper}>
                      <div className={classesK.oddsContainer}>
                        <span>Upiši prolaz ( Da / Ne )</span>
                        <input
                          type='text'
                          value={data.values[serieKey].hasPassed}
                          onChange={(e) => {
                            const value = e.target.value
                            setData((prevData) => ({
                              ...prevData,
                              values: {
                                ...prevData.values,
                                [serieKey]: {
                                  ...prevData.values[serieKey],
                                  hasPassed: value,
                                },
                              },
                            }))
                          }}
                          style={{ width: '100%' }}
                        />
                      </div>

                      <div className={classesK.oddsContainer}>
                        <span>Upiši procenat ( prenos u sledeći krug )</span>
                        <input
                          type='number'
                          value={data.values[serieKey].percentage}
                          onChange={(e) => {
                            const value = e.target.value
                            setData((prevData) => ({
                              ...prevData,
                              values: {
                                ...prevData.values,
                                [serieKey]: {
                                  ...prevData.values[serieKey],
                                  percentage: value,
                                },
                              },
                            }))
                          }}
                          step='1'
                          min='1'
                          style={{ width: '100%' }}
                        />
                      </div>
                    </div>

                    <div className={classes.wrapper}>
                      <ResultsSection
                        results={[data.result[`${serieKey}Results`][0]]}
                        names={['Potencijalni dobitak']}
                        allowNegative={true}
                      />
                      <ResultsSection
                        results={[data.result[`${serieKey}Results`][1]]}
                        names={['Čista dobit']}
                        allowNegative={true}
                      />
                      <ResultsSection
                        results={[data.result[`${serieKey}Results`][2]]}
                        names={['Prenos u unitima']}
                        allowNegative={true}
                      />
                    </div>

                    <div className={classes.wrapper}>
                      <ResultsSection
                        results={[data.result[`${serieKey}Results`][3]]}
                        names={['Trenutno stanje']}
                        allowNegative={true}
                      />

                      <div className={classesK.oddsContainer}>
                        <span>Upiši ulog promašaja</span>
                        <input
                          type='number'
                          value={data.values[serieKey].missOdds}
                          onChange={(e) => {
                            const value = e.target.value
                            setData((prevData) => ({
                              ...prevData,
                              values: {
                                ...prevData.values,
                                [serieKey]: {
                                  ...prevData.values[serieKey],
                                  missOdds: value,
                                },
                              },
                            }))
                          }}
                          step='1'
                          min='1'
                          style={{ width: '100%' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}

            {series.length < 25 && (
              <div style={{ marginTop: '5px' }} className={classesK.addMore}>
                <button onClick={addSeries} className={classesK.addButton}>
                  <img src={add} height={18} width={18} alt='image' />
                  Dodaj još jednu seriju
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default PozitivnaLinija
